/*import { register } from "register-service-worker"

if (process.env.NODE_ENV === "production") {
    register(`${process.env.BASE_URL}firebase-messaging-sw.js`, {
        ready() {
            console.log("App is being served from cache by a service worker.\n")
        },
        cached() {
            console.log("Content has been cached for offline use.")
        },
        updated() {
            console.log("New content is available; please refresh.")
        },
        offline() {
            console.log("No internet connection found. App is running in offline mode.")
        },
        error(error) {
            console.error("Error during service worker registration:", error)
        }
    })
}
*/

import store from "@/store"
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
    navigator.serviceWorker
        .register(`${process.env.BASE_URL}firebase-messaging-sw.js`)
        .then((reg) => {
            reg.addEventListener("updatefound", () => {
                console.log("update found")
                const newWorker = reg.installing
                newWorker.addEventListener("statechange", () => {
                    if (newWorker.state === "installed") {
                        if (navigator.serviceWorker.controller) {
                            store.commit("needUpdate", true)
                        }
                    }
                })
            })
        })
}
